import { render, staticRenderFns } from "./SubtasksManager.vue?vue&type=template&id=525dc902&"
import script from "./SubtasksManager.vue?vue&type=script&lang=js&"
export * from "./SubtasksManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports